var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquatorialGuinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73932 10.4456H31.0049C28.7443 4.35274 22.8796 0.0107422 16.0002 0.0107422C11.5818 0.0107422 7.58226 1.80193 4.68701 4.69755L9.73932 10.4456Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73932 21.576H31.0049C28.7443 27.6688 22.8796 32.0108 16.0002 32.0108C11.5818 32.0108 7.58226 30.2196 4.68701 27.324L9.73932 21.576Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68628 4.69702C-1.56209 10.9454 -1.56209 21.0761 4.68628 27.3245C7.26834 24.7425 9.75166 22.2591 16 16.0108L4.68628 4.69702Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7827 13.2281V16.7063C18.7827 18.8363 21.5653 19.489 21.5653 19.489C21.5653 19.489 24.348 18.8363 24.348 16.7063V13.2281H18.7827Z",
    fill: "#DEDDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8695 16.0805H22.2608V18.0979H20.8695V16.0805Z",
    fill: "#786145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9566 15.3152C22.9566 14.5468 22.3338 13.9239 21.5653 13.9239C20.7969 13.9239 20.174 14.5468 20.174 15.3152C19.7898 15.3152 19.4784 15.6267 19.4784 16.0109C19.4784 16.395 19.7898 16.7065 20.174 16.7065H22.9566C23.3408 16.7065 23.6523 16.395 23.6523 16.0109C23.6523 15.6267 23.3409 15.3152 22.9566 15.3152V15.3152Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquatorialGuinea);
export default __webpack_public_path__ + "static/media/equatorial-guinea.f8c2fd22.svg";
export { ForwardRef as ReactComponent };